module.exports = "/img/nodata.e8a9b80c.png";